export default __webpack_public_path__ + "static/media/docker.5cbea947.svg";